import React from 'react';
import Lookup from '../componentes/select-async';
import { autobind } from 'core-decorators';
import FaixaFarolEdit from '../paginas/faixa-farol/edit';
import FaixaFarolList from '../paginas/faixa-farol/index';

@autobind
class FaixaFarolLookup extends React.Component {
  render() {
    return (
      <Lookup
        labelKey="descricao"
        valueKey="id"
        showSearch
        searchComponent={FaixaFarolList}
        clearable={true}
        editComponent={FaixaFarolEdit}
        url="/FaixaFarolLookup"
        {...this.props}
      />
    );
  }
}

export default FaixaFarolLookup;
